import React, {useState, useEffect, useRef} from 'react'
import {getRemainingTimeFromMS} from '../utils/get-remaining-time-from-ms'

function ExpiryCountdownTimer({
  countdownTimeMS,
  isHourlyNeeded = false,
  isMobileView = false,
  unitBelow = false,
}) {
  const expiryTimestamp = useRef(Date.now() + countdownTimeMS)
  const [remainingTime, setRemainingTime] = useState(() =>
    getRemainingTimeFromMS(expiryTimestamp.current),
  )

  useEffect(() => {
    const totalSeconds =
      Number(remainingTime.days || 0) * 86400 +
      Number(remainingTime.hours) * 3600 +
      Number(remainingTime.minutes) * 60 +
      Number(remainingTime.seconds)
    if (totalSeconds >= 1) {
      const intervalId = setInterval(() => {
        setRemainingTime(getRemainingTimeFromMS(expiryTimestamp.current))
      }, 1000)
      return () => clearInterval(intervalId)
    } else {
      //will write something
    }
  }, [
    remainingTime.days,
    remainingTime.hours,
    remainingTime.minutes,
    remainingTime.seconds,
  ])

  useEffect(() => {
    window.addEventListener('beforeunload', ev => {
      ev.preventDefault()
      return (ev.returnValue = 'Are you sure you want to close?')
    })
  }, [])

  function isScheduleExpired() {
    return (
      Number(remainingTime.days || 0) * 86400 +
        Number(remainingTime.hours) * 3600 +
        Number(remainingTime.minutes) * 60 +
        Number(remainingTime.seconds) >
      0
    )
  }

  const countdownValue = (() => {
    if (isHourlyNeeded) {
      if (Number(remainingTime.days) > 0) {
        const days = Number(remainingTime.days)
        const hasSubDayRemainder =
          Number(remainingTime.hours) > 0 ||
          Number(remainingTime.minutes) > 0 ||
          Number(remainingTime.seconds) > 0
        return {
          value: String(hasSubDayRemainder ? days + 1 : days),
          unit: 'Days',
        }
      }
      return {
        value: `${remainingTime.hours}:${remainingTime.minutes}:${remainingTime.seconds}`,
        unit: 'Hrs',
      }
    }
    return {
      value: `${remainingTime.minutes}:${remainingTime.seconds}`,
      unit: 'Min',
    }
  })()

  const mobileTextStyle = {
    color: '#FF5000',
    fontFamily: 'Open Sans',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '100%',
  }

  return isScheduleExpired() ? (
    <div style={{display: 'flex', alignItems: 'center', gap: '16px'}}>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        {isMobileView ? (
          <span style={mobileTextStyle}>Payment link will expire in</span>
        ) : (
          <>
            <span className="payment-header-label">Payment link</span>
            <span className="payment-header-value">will expire in</span>
          </>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: unitBelow ? 'column' : 'row',
          alignItems: 'center',
          gap: unitBelow ? '4px' : '6px',
        }}
      >
        <div
          style={{
            background: '#ECEEF147',
            borderRadius: '8px',
            height: '36px',
            paddingInline: '6px',
            color: isMobileView ? '#FF5000' : 'white',
            fontFamily: 'Open Sans',
            fontWeight: 700,
            fontStyle: 'normal',
            fontSize: '22px',
            lineHeight: '100%',
            letterSpacing: '0%',
            textAlign: 'center',
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {countdownValue.value}
        </div>
        <span
          style={{
            color: isMobileView ? '#FF5000' : 'white',
            fontFamily: 'Open Sans',
            fontWeight: 700,
            fontSize: '14px',
            lineHeight: '100%',
            letterSpacing: '0px',
            textAlign: 'center',
          }}
        >
          {countdownValue.unit}
        </span>
      </div>
    </div>
  ) : (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 9999,
      }}
    >
      <div
        style={{
          background: 'white',
          borderRadius: '8px',
          padding: '32px',
          maxWidth: '480px',
          width: '100%',
        }}
      >
        <h2 style={{marginBottom: '16px'}}>Payment Link Expired</h2>
        <p style={{color: '#4d4d4d', fontSize: '18px'}}>
          {`Your payment link have expired. Please close this window and contact
        Business Consultant — They'll be happy to generate new payment link.`}
        </p>
      </div>
    </div>
  )
}

export default ExpiryCountdownTimer
